<template>
  <section>
    <el-row  style="min-width:1100px;padding:15px;margin-bottom:30px">
      <el-col :span="3">
        <el-button type="text" @click="jump">点击下载SDK说明文档</el-button>
      </el-col>
      <el-col :span="5" :offset="16">
        <div style="float:right;min-width:40px">
          <el-button size="small" type="primary" @click="add">新增</el-button>
        </div>
      </el-col>
    </el-row>
    <el-timeline>
      <el-timeline-item
        v-for="(v,i) in list"
        :key="i"
        placement="top"
        size="large"
        icon="el-icon-time"
      >
        <div @click="edit(v)">
        <el-card style="max-width:500px" >
          <h4>SDK {{v.version}}</h4>
          <p>更新时间:{{v.update_time}}</p>
          <p>{{v.content}}</p>
        </el-card>
        </div>

      </el-timeline-item>
      <el-timeline-item placement="top"></el-timeline-item>
    </el-timeline>

    <el-dialog :title="isAdd?'新增版本':'编辑版本'" :visible.sync="addDialog"  width="500px" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="SDK版本号" label-width="120px">
          <el-input v-model="form.version" placeholder="请输入SDK版本号" clearable></el-input>
        </el-form-item>
        <el-form-item label="SDK更新内容"  label-width="120px">
          <el-input v-model="form.content" placeholder="请输入SDK更新内容" clearable type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { slist, saddversion,soinfo,seditversion } from "../../api/api";
export default {
  data() {
    return {
      list: [],
      pdata: {
        page: 1,
        perpage: 20
      },
      maxPage: 1,
      addDialog: false,
      form: { version: "", content: "" ,online_time:''},
      isAdd:false
    };
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      slist(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.list = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },
    log(t) {
      this.$alert(t, "更新日志");
    },
    jump() {
      window.open("http://www.baidu.com", "_blank");
    },
// saddversion,soinfo,seditversion
    submitAdd() {
      if (this.isAdd) {
          saddversion(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.getList();
              this.addDialog = false;
            }
          });
      } else {
        this.$prompt("请输入编辑原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: "内容不能为空"
        }).then(({ value }) => {
          this.form.log = value;
          seditversion(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.getList();
              this.addDialog = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        });
      }
    },
    delate() {
      var serving_id = "测";
      this.chooseList.forEach(v => {
        serving_id += "," + v.id;
      });
      var p = {
        serving_id: serving_id.slice(2),
        status: -1
      };
      sdkstatus(p, this.$cookie.getCookie("login")).then(res => {
        this.getList();
      });
    },
    add() {
      this.isAdd = true;
      this.form = { version: "", content: "" };
      this.addDialog = true;
    },
    edit(s) {
      this.isAdd = false;
      soinfo(s.id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.form.version_id = s.id;
        }
      });
      this.addDialog = true;
    },

  },
  mounted() {
    this.getList();
  }
};
</script>
<style>
.el-timeline{
  width: 500px;
}
</style>




// WEBPACK FOOTER //
// sdkInfo.vue?683c3e4d